<template>
    <div class="animated fadeIn">
        <div v-if="!viewMode" class="viewMode">
            <b-row>
                <b-col cols="12">
                    <h1>Trade Customer Templates</h1>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-card>
                        <div slot="header">
                            <strong>Templates List</strong>
                        </div>                        
                        <div class="form-container">
                            <b-row>
                                <b-col sm="4">
                                    <b-form-group>
                                        <label for="company">Company</label>
                                        <b-form-select id="company" v-if="companiesLoaded"  v-model="filterParams.company_id"
                                            :plain="true"
                                            :options="companies"
                                            :disabled="!isMinimumSuperAdmin">
                                        </b-form-select>
                                        <div v-if="!companiesLoaded" >
                                            <i class="fa fa-spin fa-spinner"></i>
                                        </div>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="4">
                                    <b-form-group>
                                        <label for="area">Area</label>
                                        <b-form-select id="area" v-if="areasLoaded"  v-model="filterParams.area_id"
                                            :plain="true"
                                            :options="areas"
                                            :disabled="!isMinimumCompanyUser">
                                        </b-form-select>
                                        <div v-if="!areasLoaded" >
                                        <i class="fa fa-spin fa-spinner"></i> Waiting for company selection
                                        </div>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="4">
                                    <b-form-group>
                                        <label for="site">Site</label>
                                        <b-form-select id="site" v-if="sitesLoaded"  v-model="filterParams.site_id"
                                            :plain="true"
                                            :options="sites"
                                            :disabled="!isMinimumAreaUser">
                                        </b-form-select>
                                        <div v-if="!sitesLoaded" >
                                        <i class="fa fa-spin fa-spinner"></i> Waiting for area selection
                                        </div>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col sm="4">
                                    <b-form-group>
                                        <label for="showDeletedTemplates">Show Deleted</label><br/>
                                        <c-switch class="mx-1" id="showDeletedTemplates" name="showDeletedTemplates" color="primary"
                                                v-model="showDeletedTemplates" label value="1" uncheckedValue="0" dataOn="yes" dataOff="no"/>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="12" sm="8" md="8">
                                    <p>
                                        <b-button v-on:click="getTemplates" variant="primary">
                                            <i class="fa fa-search"></i>&nbsp; Fetch Templates
                                        </b-button>
                                    </p>
                                </b-col>
                            </b-row>
                            <b-row v-if="templatesLoaded">
                                <b-col sm="3">
                                    <b-form-group>
                                        <label for="tableFilter">Filter</label>
                                        <b-form-input v-model="tableFilter" type="text" id="tableFilter"></b-form-input>
                                    </b-form-group>                                    
                                </b-col>                             
                            </b-row>
                            <div v-if="templatesLoading" class="form-container">
                                <LoadingSpinner />
                            </div>
                            <div v-if="templatesLoaded" class="form-container">
                                <b-row>
                                    <b-col cols="12">
                                        <div id="customer-list">
                                            <!--<c-table :filter="tableFilter" :table-data="contactItems" :fields="tableFields" :perPage="10" hover bordered caption="All templates"></c-table>-->
                                            <b-table
                                                id="templates-table"
                                                class="datalist-table"
                                                selectable
                                                hover 
                                                bordered
                                                select-mode="single"                                            
                                                :items="templateItems" 
                                                :fields="tableFields"
                                                :filter="tableFilter"
                                                :current-page="tableCurrentPage"
                                                :per-page="tablePerPage"
                                                @row-clicked="rowSelected"
                                                responsive="sm"
                                                >
                                            </b-table>
                                        </div>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col md="6" class="my-1">
                                        <b-pagination
                                        v-model="tableCurrentPage"
                                        :total-rows="tableTotalRows"
                                        :per-page="tablePerPage"
                                        class="my-0"
                                        ></b-pagination>
                                    </b-col>
                                </b-row>
                            </div>
                        </div>
                    </b-card>
                </b-col>
            </b-row>
        </div>
        <div v-if="viewMode" class="viewMode">
            <b-row>
                <b-col cols="12">
                    <b-button v-on:click="exitViewMode" variant="secondary">
                        <i class="fa fa-arrow-circle-left"></i>&nbsp;Back
                    </b-button>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12">
                    <h1>{{selectedTemplate.template_name}}</h1>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12">
                    <b-card>
                        <div slot="header">
                            <strong>Template Information</strong>
                        </div>
                        <div v-if="!selectedTemplateLoaded" class="form-container">
                            <LoadingSpinner />
                        </div>
                        <div v-if="selectedTemplateLoaded" class="form-container">
                            <b-row>
                                <b-col cols="12" sm="12" md="12">
                                    <b-card :no-body="true" footer-class="px-3 py-2">
                                        <div slot="header">
                                            <strong>Main Details</strong>
                                        </div>
                                        <b-card-body class="p-3 clearfix">
                                            <b-row>
                                                <b-col cols="12" sm="6">
                                                    <b-form-group>
                                                        <label for="templateName">Name</label>
                                                        <b-form-input v-model="selectedTemplate.template_name" type="text" id="templateName"></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col cols="12" sm="6">
                                                    <b-form-group>
                                                        <label for="templateCode">Code</label>
                                                        <b-form-input v-model="selectedTemplate.template_uuid" type="text" id="templateCode" :disabled=true></b-form-input>
                                                        <barcode
                                                        v-bind:value="selectedTemplate.template_uuid"
                                                        format="CODE39"
                                                        displayValue=false
                                                        v-bind:text="selectedTemplate.template_uuid"
                                                        >
                                                            No Barcode To Display
                                                        </barcode>
                                                    </b-form-group>
                                                </b-col> 
                                            </b-row>                                          
                                        </b-card-body>
                                    </b-card>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="12" sm="12" md="12">
                                    <b-card :no-body="true" footer-class="px-3 py-2">
                                        <div slot="header">
                                            <strong>Post Code</strong>
                                        </div>
                                        <b-card-body class="p-3 clearfix">
                                            <b-row>
                                                <b-col cols="12" sm="3">
                                                    <b-form-group>
                                                        <label for="postcodeText">Default Text</label>
                                                        <b-form-input v-model="selectedTemplate.postcode" type="text" id="postcodeText"></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col cols="12" sm="3">
                                                    <b-form-group>
                                                        <label for="postcodePosition">Position</label>
                                                        <b-form-input v-model="selectedTemplate.postcode_position" type="text" id="postcodePosition" :disabled=true></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col cols="12" sm="2">
                                                    <b-form-group>
                                                        <label for="postcodeFontSize">Font Size(mm)</label>
                                                        <b-form-input v-model="selectedTemplate.postcode_font_size" type="text" id="postcodeFontSize" :disabled=true></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col cols="12" sm="2">
                                                    <b-form-group>
                                                        <label for="postcodeRaiseBy">Raise By(mm)</label>
                                                        <b-form-input v-model="selectedTemplate.postcode_raise_by" type="text" id="postcodeRaiseBy" :disabled=true></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col cols="12" sm="2">
                                                    <b-form-group>
                                                        <label for="postcodeOffsetBy">Offset By(mm)</label>
                                                        <b-form-input v-model="selectedTemplate.postcode_offset_by" type="text" id="postcodeOffsetBy" :disabled=true></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>                                          
                                        </b-card-body>
                                    </b-card>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="12" sm="12" md="12">
                                    <b-card :no-body="true" footer-class="px-3 py-2">
                                        <div slot="header">
                                            <strong>Slogan</strong>
                                        </div>
                                        <b-card-body class="p-3 clearfix">
                                            <b-row>
                                                <b-col cols="12" sm="6">
                                                    <b-form-group>
                                                        <label for="sloganText">Default Text</label>
                                                        <b-form-input v-model="selectedTemplate.slogan" type="text" id="sloganText"></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col cols="12" sm="2">
                                                    <b-form-group>
                                                        <label for="sloganFontSize">Font Size(mm)</label>
                                                        <b-form-input v-model="selectedTemplate.slogan_font_size" type="text" id="sloganFontSize" :disabled=true></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col cols="12" sm="2">
                                                    <b-form-group>
                                                        <label for="sloganRaiseBy">Raise By(mm)</label>
                                                        <b-form-input v-model="selectedTemplate.slogan_raise_by" type="text" id="sloganRaiseBy" :disabled=true></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col cols="12" sm="2">
                                                    <b-form-group>
                                                        <label for="sloganOffsetBy">Offset By(mm)</label>
                                                        <b-form-input v-model="selectedTemplate.slogan_offset_by" type="text" id="sloganOffsetBy" :disabled=true></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                            <b-row v-if="selectedTemplate.artwork_image">
                                                <b-col>
                                                    <b-form-group>
                                                        <label>Artwork</label>
                                                        <b-img class="artwork" :src="selectedTemplate.artwork_image" />
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>                                    
                                        </b-card-body>
                                    </b-card>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="12" sm="12" md="12">
                                    <b-card :no-body="true" footer-class="px-3 py-2">
                                        <div slot="header">
                                            <strong>Border</strong>
                                        </div>
                                        <b-card-body class="p-3 clearfix">
                                            <b-row>
                                                <b-col cols="12" sm="3">
                                                    <b-form-group>
                                                        <label for="onByDefault">On By Default</label>
                                                        <b-form-input v-model="selectedTemplate.is_border" type="text" id="onByDefault" :disabled=true></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col cols="12" sm="3">
                                                    <b-form-group>
                                                        <label for="borderWidth">Border Width(mm)</label>
                                                        <b-form-input v-model="selectedTemplate.border_width" type="text" id="borderWidth" :disabled=true></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col cols="12" sm="3">
                                                    <b-form-group>
                                                        <label for="borderMargin">Border Margin(mm)</label>
                                                        <b-form-input v-model="selectedTemplate.border_margin" type="text" id="borderMargin" :disabled=true></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col cols="12" sm="3">
                                                    <b-form-group>
                                                        <label for="borderGap">Border Gap(mm)</label>
                                                        <b-form-input v-model="selectedTemplate.border_gap" type="text" id="borderGap" :disabled=true></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>                                          
                                        </b-card-body>
                                    </b-card>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="12" sm="12" md="12">
                                    <b-card :no-body="true" footer-class="px-3 py-2">
                                        <div slot="header">
                                            <strong>BSAU</strong>
                                        </div>
                                        <b-card-body class="p-3 clearfix">
                                            <b-row>
                                                <b-col cols="12" sm="3">
                                                    <b-form-group>
                                                        <label for="bsauOnByDefault">On By Default</label>
                                                        <b-form-input v-model="selectedTemplate.is_bsau_mark" type="text" id="bsauOnByDefault" :disabled=true></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col cols="12" sm="3">
                                                    <b-form-group>
                                                        <label for="bsauPrefix">Prefix</label>
                                                        <b-form-input v-model="selectedTemplate.bsau_prefix" type="text" id="bsauPrefix" :disabled=true></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col cols="12" sm="2">
                                                    <b-form-group>
                                                        <label for="bsauFontSize">Font Size(mm)</label>
                                                        <b-form-input v-model="selectedTemplate.bsau_font_size" type="text" id="bsauFontSize" :disabled=true></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col cols="12" sm="2">
                                                    <b-form-group>
                                                        <label for="bsauRaiseBy">Raise By(mm)</label>
                                                        <b-form-input v-model="selectedTemplate.bsau_raise_by" type="text" id="bsauRaiseBy" :disabled=true></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col cols="12" sm="2">
                                                    <b-form-group>
                                                        <label for="bsauOffsetBy">Offset By(mm)</label>
                                                        <b-form-input v-model="selectedTemplate.bsau_offset_by" type="text" id="bsauOffsetBy" :disabled=true></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>                                          
                                        </b-card-body>
                                    </b-card>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="12" sm="12" md="12">
                                    <b-card :no-body="true" footer-class="px-3 py-2">
                                        <div slot="header">
                                            <strong>Other</strong>
                                        </div>
                                        <b-card-body class="p-3 clearfix">
                                            <b-row>
                                                <b-col cols="12" sm="3">
                                                    <b-form-group>
                                                        <label for="marqueOnByDefault">Flag On By Default</label>
                                                        <b-form-input v-model="selectedTemplate.is_marque" type="text" id="marqueOnByDefault" :disabled=true></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col cols="12" sm="2">
                                                    <b-form-group>
                                                        <label for="marqueWidth">Flag width</label>
                                                        <b-form-input v-model="selectedTemplate.marque_width" type="text" id="marqueWidth" :disabled=true></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col cols="12" sm="2">
                                                    <b-form-group>
                                                        <label for="isLipped">Is Lipped</label>
                                                        <b-form-input v-model="selectedTemplate.is_lipped" type="text" id="isLipped" :disabled=true></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col cols="12" sm="2">
                                                    <b-form-group>
                                                        <label for="isBarcodePrinting">Barcode Printing</label>
                                                        <b-form-input v-model="selectedTemplate.is_barcode_print" type="text" id="isBarcodePrinting" :disabled=true></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col cols="12" sm="3">
                                                    <b-form-group>
                                                        <label for="totalPlatesPrinted">Total Plates Printed</label>
                                                        <b-form-input v-if="plateCountForTemplateComplete" v-model="selectedTemplate.total_plates_printed" type="text" id="totalPlatesPrinted" :disabled=true></b-form-input>
                                                        <div v-if="!plateCountForTemplateComplete">
                                                            <i class="fa fa-spin fa-spinner"></i> Counting plates...
                                                        </div>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>                                          
                                        </b-card-body>
                                    </b-card>
                                </b-col>
                            </b-row>
                            <b-row v-if="!selectedTemplate.deleted_at">
                                <b-col sm="4">
                                    <b-form-group>
                                        <label for="isDefault">Is Default</label><br/>
                                        <c-switch class="mx-1" id="isDefault" name="isDefault" color="primary"
                                                v-model="selectedTemplate.is_default" label value="1" uncheckedValue="0" dataOn="yes" dataOff="no"/>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <hr/>
                            <b-row>
                                <b-col cols="12" sm="12" md="12">
                                    <p>
                                        <b-button v-if="!selectedTemplate.deleted_at" v-on:click="saveTemplate" variant="primary" :disabled="!allowSave">
                                            <i class="fa fa-check"></i>&nbsp;Save Template
                                        </b-button>&nbsp;
                                        <b-button class="float-right" v-if="!selectedTemplate.deleted_at" v-on:click="deleteTemplate" variant="danger" :disabled="!allowSave">
                                            <i class="fa fa-times"></i>&nbsp;Delete Template
                                        </b-button>&nbsp;
                                        <b-button class="float-right" v-if="selectedTemplate.deleted_at" v-on:click="undeleteTemplate" variant="warning" :disabled="!allowSave">
                                            <i class="fa fa-undo"></i>&nbsp;Undelete Template
                                        </b-button>&nbsp;
                                    </p>
                                    <b-alert v-if="saveError" variant="danger" show><strong>Error saving data. Please try again.</strong>
                                    </b-alert>
                                    <b-alert v-if="saveInProgress" variant="info" show><strong>Saving data. Please wait...</strong>
                                    </b-alert>
                                </b-col>
                            </b-row>
                        </div>
                    </b-card>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>

import LoadingSpinner from '../../components/loadingSpinner/LoadingSpinner';
import { Switch as cSwitch } from '@coreui/vue';
import cTable from '../../components/table/Table';
import moment from 'moment';
import VueBarcode from 'vue-barcode';

const getHTTPHeaders = () => {
    let userObj = JSON.parse(localStorage.getItem('user'));
    let headerConfig = {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'Authorization': 'Bearer ' + userObj.token,
        }
    }
    return headerConfig;
}

const getCurrentUser = () => {
    return new Promise((resolve, reject) => {
        let user = JSON.parse(localStorage.getItem('user'));
        if (user != null) {
            resolve(user);
        }
        else {
            reject();
        }
        
    });
}

const getCompaniesList = (($http) => {
  return new Promise((resolve, reject) => {
    let headersObj = getHTTPHeaders();
      $http.get('getCompaniesForSelect', headersObj)
        .then((response) => {
          // let companies = response.data.companies.map((element) => {
          //   let newElement = {
          //     value: element.id,
          //     text: element.company_name
          //   };
          //   return newElement;
          // });
          resolve(response.data.companies);
        })
        .catch ((err) => {
          console.error(err);
          reject(err);
        });
  });
});

const getSiteList = (($http, areaId) => {
    return new Promise((resolve, reject) => {
        let headersObj = getHTTPHeaders();
        $http.get('getSitesForSelect?area_id=' + areaId, headersObj)
            .then((response) => {
                resolve(response.data.sites);
            })
            .catch ((err) => {
                console.error(err);
                reject(err);
            });
    });
});

const getAreaList = (($http, companyId) => {
    return new Promise((resolve, reject) => {
        let headersObj = getHTTPHeaders();
         $http.get('getAreasForSelect?company_id=' + companyId, headersObj)
            .then((response) => {
                resolve(response.data.areas);
            })
            .catch ((err) => {
                console.error(err);
                reject(err);
            });
    });
});

const getTemplates = (($http, filterObj) => {
    return new Promise((resolve, reject) => {
        let headersObj = getHTTPHeaders();
        $http.get(`templates?company_id=${filterObj.company_id}&area_id=${filterObj.area_id}&site_id=${filterObj.site_id}&is_deleted=${filterObj.is_deleted}`, headersObj)
            .then((response) => {
                resolve(response.data.templates);
            })
            .catch ((err) => {
                console.error(err);
                reject(err);
            });
    });
});

const getPlatesPrintedWithTemplateCount = (($http, template_id) => {
    return new Promise((resolve, reject) => {
        let headersObj = getHTTPHeaders();
        $http.get(`plates/printedForTemplate/${template_id}`, headersObj)
            .then((response) => {
                resolve(response.data);
            })
            .catch ((err) => {
                console.error(err);
                reject(err);
            });
    });
});

export default {
  name: 'templates',
  components: {
      LoadingSpinner: LoadingSpinner,
      cSwitch,
      cTable,
      'barcode': VueBarcode,
  },
  data () {
    return {
        viewMode: false,
        editMode: false,
        allowSave: true,
        saveError: false,
        saveInProgress: false,
        userObj: {},
        templatesLoaded: false,
        templatesLoading: false,
        selectedTemplateLoaded: false,
        plateCountForTemplateComplete: false,
        showDeletedTemplates: 0,
        templates: [],
        templateItems: [],
        seedTemplateItems: [],
        tableFilter: '',
        tablePerPage: 20,
        tableCurrentPage: 1,
        tableTotalRows: 0,
        tableFields: [
            {key: 'template_name', label: 'Template Name', sortable: true},
            {key: 'supplier_name', label: 'Trade Customer', sortable: true},
            {key: 'area_name', label: 'Branch Name', sortable: true},
            {key: 'plate_size', label: 'Plate Size', sortable: true},
            {key: 'postcode', label: 'Post Code', sortable: true},
            {key: 'is_default_text', label: 'Is Default', sortable: true}
        ],
        selectedTemplate: {},
        companiesLoaded: false,
        sitesLoaded: false,
        areasLoaded: false,
        companies: [],
        areas: [],
        sites: [],
        filterParams: {
            company_id: -1,
            area_id: -1,
            site_id: -1,
        },
        userAuthLevel : ''
    }
  },
  created () {
    getCurrentUser(this.$http)
        .then((userDetails) => {
            this.$data.filterParams.company_id = userDetails.company_id;
            this.$data.filterParams.area_id = userDetails.area_id;
            this.$data.filterParams.site_id = userDetails.site_id;
            this.$data.userAuthLevel = userDetails.auth;
            
            this.getInitialData();
            //this.setUIForCurrentUser();
            //this.getTemplates();
        })
    
  },
  watch: {
    'filterParams.company_id': function(val, oldVal) {
        
        // get the branches for the selected company
        // clear it out first
        this.$data.areas = [];
        getAreaList(this.$http, val)
            .then((areaList) => {
                if (this.$data.userAuthLevel == 'Super Admin' || this.$data.userAuthLevel == 'Company Users') {
                    this.$data.areas.push({value:0, text: 'All Areas'});
                    this.$data.filterParams.area_id = 0;
                    this.$data.filterParams.site_id = 0;
                }
                areaList.map((item) => {
                    this.$data.areas.push(item);
                });
                this.$data.areasLoaded = true;
                //this.$data.filterParams.company_id = val;
                const userFilter = {
                    company_id: this.$data.filterParams.company_id,
                    area_id: this.$data.filterParams.area_id,
                    site_id: this.$data.filterParams.site_id
                };
                
                // if (oldVal != -1) {
                //     this.getTemplates();
                // }
            })
            .catch ((err) => {
                console.error(err);
            }); 
    },
    'filterParams.area_id': function(val, oldVal) {

        // clear it out first
        this.$data.sites = [];
        this.$data.sites.push({value:0, text: 'All Sites'});
        this.$data.filterParams.site_id = 0;

        if (parseInt(val) > 0) {
            getSiteList(this.$http, val)
                .then((sitesList) => {
                    // if (this.$data.userAuthLevel == 'Super Admin' || this.$data.userAuthLevel == 'Company Users') {
                    //     this.$data.sites.push({value:0, text: 'All Sites'});
                    //     this.$data.filterParams.site_id = 0;
                    // }
                    sitesList.map((item) => {
                        this.$data.sites.push(item);
                    });
                    this.$data.sitesLoaded = true;
                    //this.filterTemplates();
                })
                .catch ((err) => {
                    console.error(err);
                });
        }
    },
    'filterParams.site_id': function(val, oldVal) {

        this.$data.filterParams.site_id = val;
        
    }
  },
  computed: {
    isMinimumSuperAdmin() {
      let returnVal = false;
      switch (this.$data.userAuthLevel) {
        case 'Super Admin':
        case 'Read Only':
          returnVal = true;
          break;
        default:
          returnVal = false;
      }
      
      return returnVal;
    },
    isMinimumCompanyUser() {
      let returnVal = false;
      console.log('Company: ', this.$data.userAuthLevel);
      switch (this.$data.userAuthLevel) {
        case 'Super Admin':
        case 'Company Users':
        case 'Read Only':
          returnVal = true;
          break;
        default:
          returnVal = false;
      }
      console.log('Company: ', returnVal);
      return returnVal;
    },
    isMinimumAreaUser() {
      let returnVal = false;
      console.log('Area: ', this.$data.userAuthLevel);
      switch (this.$data.userAuthLevel) {
        case 'Super Admin':
        case 'Company Users':
        case 'Area Users':
        case 'Read Only':
          returnVal = true;
          break;
        default:
          returnVal = false;
      }
      console.log('Area: ', returnVal);
      return returnVal;
    },
    isMinimumSiteUser() {
      let returnVal = false;
      console.log('Site: ', this.$data.userAuthLevel);
      switch (this.$data.userAuthLevel) {
        case 'Super Admin':
        case 'Company Users':
        case 'Area Users':
        case 'Site Users':
        case 'Read Only':
          returnVal = true;
          break;
        default:
          returnVal = false;
      }
      
      return returnVal;
    }
  },
  methods : {
    setUIForCurrentUser() {
        getCurrentUser()
            .then((userDetails) => {
            this.$data.filterParams.company_id = userDetails.company_id;
            this.$data.filterParams.area_id = userDetails.area_id;
            this.$data.filterParams.site_id = userDetails.site_id;
            this.$data.userAuthLevel = userDetails.auth;
        })
    },
    getInitialData() {
      getCompaniesList(this.$http)
        .then((results) => {
          this.$data.companies = results;
          this.$data.companiesLoaded = true;
        });
    },
    async rowSelected(item, index) {
        this.$data.selectedTemplateLoaded = false;
        this.enterViewMode();
        this.$data.selectedTemplate = item;
        this.$data.plateCountForTemplateComplete = false;
        this.$data.selectedTemplateLoaded = true;

        const plateData = await getPlatesPrintedWithTemplateCount(this.$http, item.id);
        this.$data.selectedTemplate.total_plates_printed = plateData.count;
        if (moment(item.last_used).isDST()) {
            this.$data.selectedTemplate.last_used = moment(item.last_used).add(1, 'h');
        }
        else {
            this.$data.selectedTemplate.last_used = moment(item.last_used);
        }
        this.$data.plateCountForTemplateComplete = true;
    },
    getHTTPHeaders() {
        let headerConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': 'Bearer '+this.$data.userObj.token,
            }
        }
        return headerConfig;
    },
    getTemplates() {
        this.$data.templatesLoaded = false;
        this.$data.templatesLoading = true;
        const userFilter = {
            company_id: this.$data.filterParams.company_id,
            area_id: this.$data.filterParams.area_id,
            site_id: this.$data.filterParams.site_id,
            is_deleted: this.$data.showDeletedTemplates
        };
        getTemplates(this.$http, userFilter)
            .then((templatetList) => {
                this.$data.tableTotalRows = templatetList.length;
                this.$data.templateItems = templatetList.map((templateItem) => {
                    templateItem.plate_size = templateItem.plate_width + "x" + templateItem.plate_height;
                    templateItem.area_name = templateItem.area.area_name;
                    templateItem.supplier_name = templateItem.supplier.supplier_name;
                    if(templateItem.is_default) templateItem.is_default="1";
                    if (templateItem.postcode_position == null) {
                        templateItem.postcode_position = '';
                    }
                    if (templateItem.slogan == null) {
                        templateItem.slogan = '';
                    }
                    if (templateItem.is_slogan_pre_printed == null) {
                        templateItem.is_slogan_pre_printed = 0;
                    }
                    if (templateItem.slogan_offset_by == null) {
                        templateItem.slogan_offset_by = 0;
                    }
                    if (templateItem.is_marque == null) {
                        templateItem.is_marque = 0;
                    }
                    if (templateItem.marque_width == null) {
                        templateItem.marque_width = 0;
                    }
                    if (templateItem.is_bsau_mark == null) {
                        templateItem.is_bsau_mark = 0;
                    }
                    if (templateItem.bsau_prefix == null) {
                        templateItem.bsau_prefix = '';
                    }
                    if (templateItem.bsau_offset_by == null) {
                        templateItem.bsau_offset_by = 0;
                    }
                    if (templateItem.bsau_font_size == null) {
                        templateItem.bsau_font_size = 0;
                    }
                    if (templateItem.bsau_raise_by == null) {
                        templateItem.bsau_raise_by = 0;
                    }
                    
                    templateItem.is_default_text = templateItem.is_default == 0 ? 'No' : 'Yes';
                    templateItem.is_slogan_pre_printed = templateItem.is_slogan_pre_printed == 0 ? 'No' : 'Yes';
                    templateItem.is_border_pre_printed = templateItem.is_border_pre_printed == 0 ? 'No' : 'Yes';
                    templateItem.is_border = templateItem.is_border == 0 ? 'No' : 'Yes';
                    templateItem.is_marque = templateItem.is_marque == 0 ? 'No' : 'Yes';
                    templateItem.is_bsau_mark = templateItem.is_bsau_mark == 0 ? 'No' : 'Yes';
                    templateItem.is_barcode_print = templateItem.is_barcode_print == 0 ? 'No' : 'Yes';
                    templateItem.is_lipped = templateItem.is_lipped == 0 ? 'No' : 'Yes';
                    templateItem.total_plates_printed = 0;
                    return templateItem;
                });
                this.$data.seedTemplateItems = JSON.parse(JSON.stringify(this.$data.templateItems));
                this.$data.templatesLoading = false;
                this.$data.templatesLoaded = true;
            })
            .catch ((err) => {
                console.error(err);
            });
    },
    filterTemplates() {
        const userFilter = {
            company_id: this.$data.filterParams.company_id,
            area_id: this.$data.filterParams.area_id,
            site_id: this.$data.filterParams.site_id
        };
        this.$data.templateItems = this.$data.seedTemplateItems.filter((item) => {
            console.log(item);
            let returnVal = false;
            if (item.company_id == userFilter.company_id) {
                returnVal = true;
                if (userFilter.area_id == 0) {
                    returnVal = true;
                } else {
                    console.log(item.area_id == userFilter.area_id);
                    if (item.area_id == userFilter.area_id) {
                        console.log(userFilter);
                        if (userFilter.site_id == 0) {
                            returnVal = true;
                        }
                        else {
                            if (item.dealership_id == userFilter.site_id) {
                                returnVal = true;
                            }
                            else {
                                returnVal = false;
                            }
                        }
                    }
                    else {
                        returnVal = false;
                    }
                }
            }
            return returnVal;
        });
        this.$data.tableTotalRows = this.$data.templateItems.length;
    },
    exitViewMode() {
        this.$data.viewMode = false;
    },
    enterViewMode() {
        this.$data.viewMode = true;
    },
    async deleteTemplate() {
        // let dataPostObject = {
        //     template: {
        //         is_deleted: 1
        //     }
        // }
        // this.postUpdate(dataPostObject);
        const headersObj = getHTTPHeaders();
        const response = await this.$http.delete('template/'+this.$data.selectedTemplate.id,headersObj);

        if (false === response.data.success) {
            this.$data.saveError = true;
        } else {
            this.exitViewMode();
            this.getTemplates();
        }
    },
    async undeleteTemplate() {
        // let dataPostObject = {
        //     template: {
        //         is_deleted: 0
        //     }
        // }
        // this.postUpdate(dataPostObject);
        const headersObj = getHTTPHeaders();
        const response = await this.$http.put('template/undelete/'+this.$data.selectedTemplate.id,null,headersObj);

        if (false === response.data.success) {
            this.$data.saveError = true;
        } else {
            this.exitViewMode();
            this.getTemplates();
        }
    },
    async saveTemplate() {
        // let dataPostObject = {
        //     template: {
        //         is_default: this.$data.selectedTemplate.is_default
        //     }
        // }
        // this.postUpdate(dataPostObject);
        this.postUpdate();
        
    },
    async postUpdate() {
        const headersObj = getHTTPHeaders();
        const response = await this.$http.put('setDefaultTemplateStatus/'+this.$data.selectedTemplate.id, {
                is_default: this.$data.selectedTemplate.is_default,
                template_name: this.$data.selectedTemplate.template_name,
                slogan: this.$data.selectedTemplate.slogan,
                postcode: this.$data.selectedTemplate.postcode
            },
        headersObj);

        if (false === response.data.success) {
            this.$data.saveError = true;
        } else {
            this.exitViewMode();
            this.getTemplates();
        }
    }
  }
}
</script>

<style>
img.artwork {
    max-height: 60px;
    border: 1px solid #e4e7ea;
    padding: 5px;
    border-radius: 5px;
    display: block;
}
svg.vue-barcode-element {
    width: 100% !important;
    height: 100% !important;
    margin-top: 24px;
}
</style>
